import { createReducer, on } from '@ngrx/store';
import { articleContentAddedToDOM, articleContentRemovedFromDOM } from './piano.app.actions';
import type { PianoState } from './piano.app.model';

export const PIANO_FEATURE_KEY = 'piano';

export interface PianoPartialState {
  readonly [PIANO_FEATURE_KEY]: PianoState;
}

const initialState: PianoState = {
  articleElementsAreInDOM: false,
};

export const pianoReducer = createReducer<PianoState>(
  initialState,
  on(articleContentAddedToDOM, (state) => ({
    ...state,
    articleElementsAreInDOM: true,
  })),
  on(articleContentRemovedFromDOM, (state) => ({
    ...state,
    articleElementsAreInDOM: false,
  }))
);
